export default __webpack_public_path__ + "static/media/midasi_entry_ko_sp.51cfb64f.png";